import ApprovalWarrantyPanelComponent from "./approvalWarrantyPanel.container";

export default ApprovalWarrantyPanelComponent;